import { render, staticRenderFns } from "./viewsModal.vue?vue&type=template&id=a851680e&scoped=true&"
import script from "./viewsModal.vue?vue&type=script&lang=js&"
export * from "./viewsModal.vue?vue&type=script&lang=js&"
import style0 from "./viewsModal.vue?vue&type=style&index=0&id=a851680e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a851680e",
  null
  
)

export default component.exports